import React from 'react'
import Spinner from '../../common/Spinners/Spinner'
import history from '../../core/history'

class AdviserLogin extends React.Component {
  componentDidMount () {
    history.push('//secure.uat.gray.net', {})
  }

  render () {
    return <Spinner />
  }
}

export default AdviserLogin
